import { IconFont, Text, Tooltip } from '@byecode/ui'
import { useCurrentEditor } from '@tiptap/react'
import React from 'react'

import { useLanguageContext } from '../../../contexts'
import { CustomActionIcon } from './styles'

export const TableMenu = () => {
    const { editor } = useCurrentEditor()
    const { convertTextByLanguage } = useLanguageContext()

    return (
        <Tooltip
            title={
                <div style={{ textAlign: 'center' }}>
                    <Text>{convertTextByLanguage('insertTable')}</Text>
                    <Text color="var(--color-gray-400)">3 x 3</Text>
                </div>
            }
        >
            <CustomActionIcon
                onClick={() => {
                    editor?.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: false }).run()
                }}
            >
                <IconFont type="NewTable" />
            </CustomActionIcon>
        </Tooltip>
    )
}
